import { styled, SxProps, Theme, Typography } from '@mui/material';
import { ButtonGroup, Button, ButtonProps } from '@mui/material';
import { NOT_USE_TAB } from '../../utils/constants';
import React from 'react';

interface StyledButtonGroupProps {
  height?: string;
}

// ButtonGroup Style
const StyledButtonGroup = styled(ButtonGroup)<StyledButtonGroupProps>(props => ({
  width: '100%',
  height: props.height ? props.height : 'auto',
  margin: 'auto',
}));

// ButtonLeft Style

interface StyledButtonProps extends ButtonProps {
  group_type?: string;
}

const StyledLeftButton = styled(Button)<StyledButtonProps>(props => ({
  textAlign: 'center',
  border: 'none',
  boxShadow: 'none',

  '&.MuiButtonGroup-grouped': {
    minWidth: '0',
    padding: '0',
  },
  '&:active': {
    border: 'none',
    boxShadow: 'none',
  },
  '&:hover': {
    border: 'none',
    boxShadow: 'none',
  },
  fontFamily: "'Apple SD Gothic Neo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue'",
  width: '50%',
  marginLeft: '0',
  fontWeight: '500',
  fontSize: '1rem',
  // sapn tag style
  span: {
    fontWeight: 'normal',
  },
  //
  '&.MuiButton-outlined': {
    width: '50%',
    backgroundColor: props.className === 'attendance' ? '#1bd05b' : '#fff',
    border: `${props.className === 'attendance' ? '1px solid #1bd05b' : '1px solid rgba(0, 0, 0, 0.2)'}`,
    borderRight: 'none',
    color: props.className === 'attendance' ? '#fff' : 'rgb(159, 159, 159)',
    '&:hover': {
      border: `${props.className === 'attendance' ? '1px solid #1bd05b' : '1px solid rgba(0, 0, 0, 0.2)'}`,
      borderRight: 'none',
    },
  },
}));

// ButtonRight Style
const StyledRightButton = styled(Button)<StyledButtonProps>(props => {
  return {
    '&.MuiButtonGroup-grouped:not(:first-of-type)': {
      textAlign: 'center',
      border:
        props.className === 'attendance' || props.className === 'counseling' ? '1px solid rgb(255, 214, 0)' : 'none',
      backgroundColor: props.className === 'attendance' ? 'rgb(255, 214, 0)' : '',
      boxShadow: 'none',

      '&.MuiButtonGroup-grouped': {
        minWidth: '0',
        padding: '0',
      },
      '&:active': {
        border: 'none',
        boxShadow: 'none',
      },
      '&:hover': {
        border:
          props.className === 'attendance' || props.className === 'counseling' ? '1px solid rgb(255, 214, 0)' : 'none',
        boxShadow: 'none',
      },
      fontFamily: "'Apple SD Gothic Neo', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue'",
      width: '50%',
      marginLeft: 0,
      fontWeight: '500',
      fontSize: '1rem',
      // span tag style
      span: {
        fontWeight: 'normal',
      },
      //
      '&.MuiButton-outlined': {
        width: '50%',
        border: `${
          props.className === 'attendance' || props.className === 'counseling'
            ? '1px solid rgb(255, 214, 0)'
            : '1px solid rgba(0, 0, 0, 0.2)'
        }`,
        color: props.className === 'attendance' ? '#fff' : 'rgb(159, 159, 159)',

        backgroundColor: props.className === 'attendance' ? 'rgb(255, 214, 0)' : '#fff',
        borderLeft: 'none',
        span: {
          fontWeight: 'normal',
        },
        '&:hover': {
          // border: `${
          //   props.className === 'attendance' || props.title === 'counseling'
          //     ? '1px solid rgb(46, 206, 115)'
          //     : '1px solid rgba(0, 0, 0, 0.2)'
          // }`,
          // borderLeft: 'none',
        },
        '&.Mui-disabled': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
          border: 'none',
          borderLeft: '3px solid var(--gray-3)',
        },
      },
    },
  };
});

// props로 받을 수 있는 데이터의 형식 정의
interface ButtonGroupProps {
  defaultType: string;
  type: 'pc' | 'pc2' | 'sms' | 'payment' | 'message_content' | 'message_setting' | 'attendance' | 'counseling';
  onClick: (type: string, default_type?: string, index?: number) => void;
  disabled?: boolean;
  height?: string;
  sx?: SxProps<Theme>;
  index?: number;
}

// type(props)의 Type 정의
const pc: ButtonGroupType = {
  size: {},
  color: ['green', 'gray_off'],
  text: ['ON', 'OFF'],
};

const pc2: ButtonGroupType = {
  size: {},
  color: ['green', 'yellow_1'],
  text: ['등원 내역', '하원 내역'],
};

const sms: ButtonGroupType = {
  size: {},
  color: ['green', 'yellow_1'],
  text: ['SMS 문자', '알림톡'],
};

const payment: ButtonGroupType = {
  size: {},
  color: ['green', 'red'],
  text: ['ON', 'OFF'],
};

const message_content: ButtonGroupType = {
  size: {},
  color: ['green', 'green'],
  text: ['ON', 'OFF'],
};

const message_setting: ButtonGroupType = {
  size: {},
  color: ['yellow_1', 'green'],
  text: ['알림톡', 'SMS 문자'],
};

const attendance: ButtonGroupType = {
  size: {},
  color: ['green', 'green'],
  text: ['출결분석 출력', '출결내역 저장'],
};

const counseling: ButtonGroupType = {
  size: {},
  color: ['green', 'green'],
  text: ['상담일지 출력', '상담일지 저장'],
};

const group_button_type = { pc, pc2, sms, payment, message_content, message_setting, attendance, counseling };

// 컴포넌트 로직
function CustomButtonGroup(props: ButtonGroupProps) {
  const type = group_button_type[props.type];
  const default_type = props.defaultType;
  const disabled = props.disabled;
  const height = props.height;
  const sx = props.sx;
  const index = props.index;

  return (
    <StyledButtonGroup
      id='button_group'
      className='button_group'
      disableRipple={true}
      disabled={disabled}
      height={height}
      tabIndex={NOT_USE_TAB}
    >
      <StyledLeftButton
        variant={default_type === 'left' ? 'contained' : 'outlined'}
        color={default_type === 'left' ? type.color[0] : props.type === 'attendance' ? 'green' : 'gray_1'}
        sx={sx}
        style={{ borderRight: 'none' }}
        onClick={() => props.onClick('left', default_type, index)}
        className={type.text[0] === '출결분석 출력' ? 'attendance' : ''}
        tabIndex={NOT_USE_TAB}
      >
        {type.text[0]}
        {type.text[0] === '출결분석 출력' ? (
          <Typography component='span' sx={{ marginLeft: '4px' }}>
            (학생)
          </Typography>
        ) : null}
      </StyledLeftButton>
      <StyledRightButton
        title={props.type}
        variant={default_type === 'right' ? 'contained' : 'outlined'}
        color={
          default_type === 'right'
            ? type.color[1]
            : props.type === 'attendance' || props.type === 'counseling'
            ? 'green'
            : 'gray_1'
        }
        sx={sx}
        style={{ borderLeft: 'none' }}
        onClick={() => props.onClick('right', default_type, index)}
        className={['상담일지 저장', '출결내역 저장'].includes(type.text[1]) ? 'attendance' : ''}
        tabIndex={NOT_USE_TAB}
      >
        {type.text[1]}
        {type.text[1] === '출결내역 저장' ? (
          <Typography component='span' sx={{ marginLeft: '4px' }}>
            (전체반)
          </Typography>
        ) : null}
      </StyledRightButton>
    </StyledButtonGroup>
  );
}

export default CustomButtonGroup;
